import { Container } from "react-bootstrap";

const MentionsLegales = () => {
  return (
    <Container className="my-5">
      <h1 className="mb-4">Mentions légales</h1>

      <h4>Éditeur du site</h4>
      <p>
        <strong>Nom de l’entreprise :</strong> Renovestim<br />
        <strong>Numéro SIRET :</strong>79256301700021<br />
        <strong>Responsable de la publication :</strong> Jérémie Hucher<br />
        <strong>Email :</strong> contact@renovestim.com
      </p>

      <h4>Hébergement</h4>
      <p>
        <strong>Hébergeur :</strong> Render.com<br />
        <strong>Adresse :</strong> 300 California Street, San Francisco, CA 94104, USA<br />
        <strong>Site Web :</strong> <a href="https://render.com" target="_blank" rel="noopener noreferrer">render.com</a>
      </p>
      <p>
        <strong>Hébergeur :</strong> Vercel.com<br />
        <strong>Adresse :</strong> 340 S Lemon Ave, Walnut, CA 91789, USA<br />
        <strong>Site Web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">vercel.com</a>
      </p>

      <h4>Propriété intellectuelle</h4>
      <p>
        Le contenu du site Renovestim (structure, design, textes, images, etc.) est la propriété exclusive de Renovestim, sauf mention contraire. Toute reproduction, totale ou partielle, est interdite sans autorisation écrite préalable.
      </p>

      <h4>Responsabilité</h4>
      <p>
        Renovestim s’efforce de fournir des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes ou des carences dans la mise à jour du site.
      </p>

      <h4>Liens hypertextes</h4>
      <p>
        Le site peut contenir des liens vers d’autres sites. Renovestim n’exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
      </p>

      <h4>Protection des données personnelles</h4>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de rectification, de suppression, et d’opposition à vos données personnelles. Pour exercer vos droits, vous pouvez contacter : <strong>contact@renovestim.com</strong>.
      </p>

      <h4>Gestion des cookies</h4>
      <p>
        Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visites. Pour en savoir plus sur la manière dont nous utilisons les cookies et comment les gérer, veuillez consulter notre <a href="/politique-cookies">Politique de gestion des cookies</a>.
      </p>

      <h4>Dernière mise à jour</h4>
      <p>Cette page a été mise à jour le {new Date().toLocaleDateString("fr-FR")}</p>
    </Container>
  );
};

export default MentionsLegales;
